import React from 'react';

import { Text } from '@qality/common-components/src/atoms/Text';
import { User } from '@qality/common-components/src/atoms/User';
import { AUTOMATED_EXECUTION_USER } from '@qality/common-components/src/picker/UserPicker';
import { ReportAvatarCell } from '@qality/common-model';
import { StorageOfUniqueServices } from '@qality/common-service';

type Props = {
  cell: ReportAvatarCell;
};

export default function ReportAvatarColumn({ cell }: Props): JSX.Element {
  const shouldDisplayAvatar = cell && cell.displayName !== '-';

  if (!shouldDisplayAvatar) {
    return <Text inactive>Unassigned</Text>;
  }

  let avatarUrl = cell.avatarUrl;
  if (cell.accountId === AUTOMATED_EXECUTION_USER.value) {
    avatarUrl = StorageOfUniqueServices.get('URLService').getQAlityIssueIcon();
  }

  return (
    <User userName={cell.displayName} userAvatar={avatarUrl} size='xsmall' />
  );
}
